<template>
    <div :class="['scope-textarea', { '-full-width': fullWidth }]">
        <div class="scope-textarea__label" v-if="label">{{ label }}</div>
        <div class="scope-textarea__prompt" v-if="prompt">{{ prompt }}</div>
        <textarea
            :disabled="disabled"
            :class="[{ '-invalid': invalid }]"
            v-model="vModel"
            :style="styles"
            :placeholder="placeholder"
            @input="emit('input')"
            :veeBind="veeBind"
            @keyup.enter="emit('enter')"
            :maxlength="maxLength"
        />
        <div class="scope-textarea__error" v-if="invalid">
            {{ errorMessage }}
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const emit = defineEmits(['input', 'enter']);

const vModel = defineModel();
const props = defineProps({
    maxLength: {
        type: Number,
        default: 524288
    },
    placeholder: String,
    veeBind: Object,
    invalid: Boolean,
    fullWidth: Boolean,
    errorMessage: String,
    label: String,
    disabled: Boolean,
    width: String,
    prompt: String
});
const styles = computed(() =>
    props.width || props.height
        ? { width: props.width, height: props.height }
        : null
);
</script>

<style lang="scss" scoped>
@import '../assets/styles/_main.scss';

.scope-textarea {
    display: flex;
    flex-direction: column;
    gap: 12px;

    position: relative;
    width: fit-content;

    &.-full-width {
        width: 100%;
    }

    textarea {
        position: relative;

        border: 1px solid $border;
        border-radius: 10px;
        outline: none;
        padding: 12px;

        display: flex;
        align-items: center;

        font-family: 'Geist', sans-serif;
        font-optical-sizing: auto;
        @include fz-14;
        resize: none;

        color: $text-high-emphasis;
        z-index: 10;

        width: 100%;
        height: 100%;

        text-overflow: ellipsis;
        background-color: $card-background;

        &:disabled {
            opacity: 0.6;
        }

        &:hover:not(:disabled) {
            border-color: $text-mid-emphasis;
        }

        &:active:not(:disabled) {
            border-color: $primary-soft;
        }

        &.-invalid {
            border-color: $border-error;
        }

        &.-side-sign {
            border-radius: 0px 10px 10px 0px;
        }
    }

    &__error {
        @include fz-12;
        font-weight: 500;
        color: $text-error-accent;
    }

    &__label {
        color: $text-mid-emphasis;
        @include fz-14;
    }

    &__prompt {
        color: $text-mid-emphasis;
        @include fz-12;
        margin-top: -4px;
    }
}
</style>
